function GradientHeader({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return (
    <h1
      className={`from-soluud-secondary to-soluud-primary animated-gradient-text mb-4 bg-gradient-to-r bg-clip-text pb-2 text-4xl font-extrabold tracking-tight text-transparent sm:text-5xl ${className ?? ""}`}
    >
      {children}
    </h1>
  );
}

export default GradientHeader;
